import { render } from "./TextInputLang.vue?vue&type=template&id=2476b87d"
import script from "./TextInputLang.vue?vue&type=script&lang=js"
export * from "./TextInputLang.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__